/**
 * Exibe o texto ao invés de undefined
 * @param predecessor Texto que vem antes caso o texto principal não seja nulo.
 * @param str Texto
 * @param sucessor Texto que vem depois caso o texto principal não seja nulo.
 * @returns Texto ou vazio.
 */
export function undefinedToTexto(
  predecessor: string,
  str: string,
  sucessor: string,
) {
  if (str && str.length > 0) return predecessor + str + sucessor;
  return '';
}

/**
 * Remove todos os espaços do texto
 * @param texto Texto original.
 * @returns texto modificado.
 */
export function TrimAll(texto: string) {
  return undefinedToTexto('', texto, '').replace(/\s/g, '');
}

/**
 * Remove acentos de um texto.
 * @param str texto de entrada.
 * @returns texto de saída.
 */
export function removerAcentos(str: string | any) {
  return String(str ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function parseQuantity(value: any): number {
  if (value == null)
    return 0;
  if (typeof value === "number")
    return Number.isFinite(value) ? value : 0;

  let s = String(value).trim();
  if (s === "")
    return 0;

  if (s.includes(",") && s.includes(".")) {

    // assume pt-BR: "." milhares, "," decimal
    s = s.replace(/\./g, "").replace(",", ".");
  } else if (s.includes(",")) {
    s = s.replace(",", ".");
  }

  s = s.replace(/[^\d.-]/g, "");
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
}

export function formatarNomePessoa(nome?: string | null, vazio: string = '-') {
  if (!nome || nome.trim() === '')
    return vazio;

  return nome
    .toLowerCase()
    .split(' ')
    .filter((p) => p.trim() !== '')
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(' ');
}
